<template>
  <div>
    <SettingGroup title="エマジェンシー・キー割当て">
      <SettingItem label="サイド 2 キーへ割当て">
        <ToggleSwitch
          v-model="form.toggle.emergency.aux"
          :disable="false"
          @input="handleUpdateEmergencyAux"
        />
      </SettingItem>
      <SettingItem label="REM キーへ割当て">
        <ToggleSwitch
          v-model="form.toggle.emergency.rem"
          :disable="false"
          @input="handleUpdateEmergencyRem"
        />
      </SettingItem>
    </SettingGroup>
  </div>
</template>

<script>
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'
import { mapStores } from 'pinia'

export default {
  name: 'EmergencyKeyAssignmentVue2',
  components: { ToggleSwitch, SettingGroup, SettingItem },
  data () {
    return {
      form: {
        toggle: {
          emergency: { aux: false, rem: false },
        },
      },
      // ストアの一時設定を保持
      setting: null,
    }
  },
  computed: {
    ...mapStores(useRadioSettingsStore),
  },
  created () {
    // ストアから一時設定を取得
    this.setting = this.radioSettingsStore.getTempSetting()

    // 設定 → フォームへ反映
    this.transSetting2Form()

    // フォーム変更を監視して 設定 ← フォーム & 保存
    this.$watch('form', () => {
      this.transForm2Setting()
      this.radioSettingsStore.saveTempSetting(this.setting)
    }, { deep: true })
  },
  methods: {
    // ===== 設定 ← フォーム =====
    transForm2Setting () {
      const data = this.setting?.KeyAssignment?.General
      if (!data || !data.Emergency) return

      data.Emergency.AUX = this.form.toggle.emergency.aux
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      data.Emergency.REM = this.form.toggle.emergency.rem
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
    },

    // ===== 設定 → フォーム =====
    transSetting2Form () {
      const data = this.setting?.KeyAssignment?.General
      if (!data || !data.Emergency) return

      this.form.toggle.emergency.aux = data.Emergency.AUX === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.emergency.rem = data.Emergency.REM === BC.COMMON.TOGGLE.ENABLE
    },

    // サイド2キー側の副作用
    handleUpdateEmergencyAux (value) {
      const data = this.setting?.KeyAssignment?.SideKey
      if (!data || !data.Side2) return

      if (value) {
        // 有効時：Side2 の Hold を Emergency に固定し、押下/離しは None
        data.Side2.HoldFunction = 'Emergency'
        data.Side2['Function(Press)'] = 'None'
        data.Side2['Function(Release)'] = 'None'
      } else {
        // 無効時：すべて None
        data.Side2.HoldFunction = 'None'
        data.Side2['Function(Press)'] = 'None'
        data.Side2['Function(Release)'] = 'None'
      }
    },

    // REMキー側の副作用
    handleUpdateEmergencyRem (value) {
      const data = this.setting?.KeyAssignment?.MicKey
      if (!data || !data.REM) return

      if (value) {
        // 有効時：REM の Hold を Emergency に固定し、押下/離しは None
        data.REM.HoldFunction = 'Emergency'
        data.REM['Function(Press)'] = 'None'
        data.REM['Function(Release)'] = 'None'
      } else {
        // 無効時：すべて None
        data.REM.HoldFunction = 'None'
        data.REM['Function(Press)'] = 'None'
        data.REM['Function(Release)'] = 'None'
      }
    },
  },
}
</script>
